export default __webpack_public_path__ + "static/media/document.db319ca5.pdf";